import React from 'react';
import getIcon from '../utils/iconMap';
import { useI18n } from '../i18n/I18nProvider';
import { useBookersContent } from '../hooks/useBookersContent';

export default function Features({ cms }) {
  const { t } = useI18n();
  const { features: fallbackFeatures } = useBookersContent();
  const f = cms || {};
  const eyebrow = f.eyebrow || t('features.eyebrow');
  const title = f.title || t('features.title');
  const description = f.description || t('features.description');
  const items = f.items || fallbackFeatures;

  return (
    <section id="features" className="bg-[#fafafb] border-y border-black/5">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 section-pad">
        <div className="max-w-3xl reveal">
          <p className="text-sm font-semibold text-[#76B828]">{eyebrow}</p>
          <h2 className="font-display text-4xl md:text-5xl mt-3 text-[#0b0b0f]">{title}</h2>
          <p className="text-[#55555f] mt-4 text-lg">{description}</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-14">
          {items.map((item, i) => {
            const Icon = typeof item.icon === 'string' ? getIcon(item.icon) : item.icon;
            return (
              <div key={item.title || i} className="reveal bg-white rounded-2xl border border-black/5 p-6 hover:shadow-[0_20px_50px_rgba(15,15,20,0.08)] hover:-translate-y-1 transition-all duration-300" style={{ transitionDelay: `${(i % 4) * 70}ms` }}>
                <span className="h-11 w-11 rounded-xl bg-[#0b0b0f] flex items-center justify-center">
                  <Icon size={20} className="text-white" />
                </span>
                <h3 className="font-semibold text-[17px] mt-4 text-[#0b0b0f]">{item.title}</h3>
                <p className="text-[#6b6b73] mt-1.5 text-sm leading-relaxed">{item.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
